import React from "react";
import useStyles from "./styles";
import clsx from "clsx";
import ScrollSyncPanel from "../ScrollSync/ScrollSyncPanel/ScrollSyncPanel";

interface Props {
  children?: React.ReactNode;
  className?: string;
  role?: string;
}

const AppPageTableRowContent = (props: Props) => {
  const { children, className } = props;
  const classes = useStyles();

  return (
    <ScrollSyncPanel
      className={clsx(classes.appPageTableRowContent, className)}
    >
      {children}
    </ScrollSyncPanel>
  );
};

export default AppPageTableRowContent;
